import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import classNames from 'classnames';
import store from 'client/store';
import { observer } from 'mobx-react';
import './GoEditBtn.scss';
import { observable } from 'mobx';

@observer
export class GoEditBtn extends React.Component {
	@observable isLoading = true;

	isShow = false;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		this.isLoading = true;
		const { record } = this.props;
		this.isShow = record?.hasOwnProperty('organizationId') && store.model.user?.organizationId === record.organizationId;
		this.isShow = this.isShow && record?.hasOwnProperty('languageId') && (await store.getIsSuccessLanguage(record.languageId));
		this.isShow = store.isAdmin || this.isShow;
		this.isLoading = false;
	};

	render() {
		const { isLoading, isShow } = this;
		const { path, className, record, ...restProps } = this.props;

		if (isLoading || !isShow) return null;

		return (
			<a href={path} className={classNames('GoEditBtn', className)} {...restProps}>
				<FontAwesomeIcon icon={faPenToSquare} class='edit-icon' />
			</a>
		);
	}
}
